import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgMessage = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.0166 3.23486C17.5498 3.23486 21.999 6.87919 21.999 11.3742C21.999 13.3159 21.1636 15.091 19.7697 16.4887C20.2588 18.4602 21.8934 20.2168 21.9129 20.2364C22.001 20.3244 22.0254 20.4607 21.9716 20.5781C21.9227 20.6955 21.8143 20.7646 21.6871 20.7646C19.0946 20.7646 17.1831 19.5218 16.1852 18.7537C14.9083 19.233 13.4843 19.5124 11.9825 19.5124C6.44926 19.5124 2 15.8681 2 11.4083C2 6.94845 6.48335 3.23486 12.0166 3.23486ZM8.11726 14.54H12.5C13.0165 14.54 13.4392 14.1213 13.4392 13.6008C13.4392 13.0804 13.0165 12.6617 12.5 12.6617H8.11726C7.59681 12.6617 7.1781 13.0843 7.1781 13.6008C7.1781 14.1174 7.59681 14.54 8.11726 14.54ZM7.94687 10.7833H16.0862C16.6028 10.7833 17.0254 10.3646 17.0254 9.84419C17.0254 9.32374 16.6028 8.90503 16.0862 8.90503H7.94687C7.42642 8.90503 7.00771 9.32765 7.00771 9.84419C7.00771 10.3607 7.42642 10.7833 7.94687 10.7833Z", fill: props.fill }));
});
export default SvgMessage;
